import { render, staticRenderFns } from "./JournalSummaryAnalysis.vue?vue&type=template&id=667f3700"
import script from "./JournalSummaryAnalysis.vue?vue&type=script&lang=js"
export * from "./JournalSummaryAnalysis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports